<div class="content-section">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-div">
      <div class="col changeInstitution px-0">
        <div class="d-flex justify-content-between">
            <h2 class="background_title">{{ 'USER_MANAGEMENT.MANAGE_USERS' | translate }}</h2>
            <button (click)="addUser()" class="btn-continue-bordered-transparent-bd">{{ 'USER_MANAGEMENT.ADD_USER' | translate }}</button>
        </div>

    </div>
    </div>
    <div class="users-table">
        <div class="d-flex justify-content-end my-3">
            <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
        </div>
        <div class="col-12 static-card">
            <bd-light-table
            [gridData]="gridData || [] | search:searchText:['user','name','email','role','roleName','institutions','city','institutionName']"
            [pageInfo]="pageInfo" [fields]="fields" [actions]="actionItems"></bd-light-table>
        </div>
        <!-- <lib-ph-bhp-grid [gridData]="gridData | search:searchText:['user','name','email','role','roleName','institutions','city','institutionName']"
        [fields]="fields" [horizontalAction]="true" [gridGroupable]="true" [pageInfo]="pageInfo" [actionItems]="actionItems"></lib-ph-bhp-grid> -->
    </div>

  </div>


<ng-template #delmodal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body">
        <p> {{ 'USER_MANAGEMENT.DELETE_USER' | translate}} </p>
        <br />
        <p> {{ 'USER_MANAGEMENT.DELETE_USER_CONFIRMATION' | translate}} </p>
    </div>
    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'AUTHORIZATION.CANCEL' | translate }}</button>
            <button (click)="delete();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
        </div>
    </div>
</ng-template>
